import { render, staticRenderFns } from "./3.vue?vue&type=template&id=074e478a&scoped=true&"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=074e478a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e478a",
  null
  
)

export default component.exports